<template>
  <div class="main">
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据大屏</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div class="main-title">
      <el-card id="main"  style="height: 400px" class="main-content"></el-card>
      <el-card id="main1" :style="{ height: count + 'px' }" class="main-content"></el-card>
    </div>

      <el-card class="pbox">
        <div class="online">
          <div>在线数量统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in title" :key="item" @click="onlineClick(index)" :class="index === onlineIndex?'active':''">{{item}}</span>
          </div>
        </div>
        <div id="main2" style="height: 300px"></div>
      </el-card>
      <el-card class="pbox">
        <div class="online">
          <div>登录次数统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in title" :key="item" @click="loginClick(index)" :class="index === loginIndex?'active':''">{{item}}</span>
          </div>
        </div>
        <div id="main3" style="height: 300px"></div>
      </el-card>
      <el-card class="pbox">
        <div class="online">
          <div>激活卡密数量统计图</div>
          <div class="datelable">
            <span v-for="(item,index) in activeTitle" :key="item" @click="activeClick(index)" :class="index === activeIndex?'active':''">{{item}}</span>
          </div>
        </div>
        <div id="main4" style="height: 300px"></div>
      </el-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      state: false,
      inputWidth: false,
      allSoftName: [],
      email: this.$store.state.account,
      queryInfo: "",
      count: 400,
      onlineNum: [],
      onlineAgainNum: [],
      censusTime: [],
      selfSeries: [],
      censusLoginTime: [],
      selfLoginSeries: [],
      censusActiveTime: [],
      selfActiveSeries: [],
      title:['今天','昨天','近7天','近30天'],
      activeTitle: ['近7天', '近30天'],
      // activeTitle: ['近7天', '近30天', '近90天'],
      onlineIndex: 0,
      loginIndex: 0,
      activeIndex: 0,

      result:"",

      option: {
        color: "#2f89cf",
        title: {
          text: "总体预览",
        },

        tooltip: {
          trigger: "axis",
          // axisPointer:{
          //   type:"shadow"
          // }
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: ["卡密总量", "已使用卡密", "已过期卡密", "当前在线"],
        },
        yAxis: {},
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "35%",
            //需要请求的数据
            //data: [5, 20, 36, 10],
            data: "",
            itemStyle: {
              barBorderRadius: 5,
            },
          },
        ],
      },

      option1: {
        color: "none",
        title: {
          text: "项目详情",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "shadow",
          // },
        },
        legend: {
          data: ["总数量", "在线数"],
        },
        grid: {
          left: "20%",
          bottom: "10%",
          top: "10%",
          containLabel: false,
        },
        xAxis: {
          show: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            //data: ["按键精灵", "AJ", "ec", "触摸", "触动"],
            data: this.allSoftName,//左边项目名
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            // axisLabel:{
            //   color:'#fff'
            // }
          },
          {
            show: true,
            inverse: true,
            //data:[702,350,610,793,664],
            data: this.projectCardNum,//每个软件卡密总数
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#333",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "在线数",
            type: "bar",
            //data: [70, 34, 60, 78, 69,300],
            data: this.onlineNum,
            //data: this.onlineAgainNum,
            barCategoryGap: 50,
            barWidth: 14,
            label: {
              show: true,
              position: "inside",
              formatter: "{c}",
            },
            yAxisIndex: 0,
            itemStyle: {
              barBorderRadius: 20,
              color: function (params) {
                let myColor = ["#1089E7", "#F57474", "#56D0E3", "#F8B448", "#8B78F6"];
                let num = myColor.length;
                return myColor[params.dataIndex % num];
                //return myColor[params.dataIndex]
              },
            },
          },
          // {
          //   name: "总数量",
          //   type: "bar",
          //   stack: "总量",
          //   //data: [1000,100,100,100,100],
          //   data: this.data,
          //   //data:this.projectCardNum,
          //   barCategoryGap: 50,
          //   yAxisIndex: 1,
          //   barWidth: 15,
          //   itemStyle: {
          //     barBorderRadius: 15,
          //     color: "none",
          //     borderColor: "#00c1de",
          //     borderWidth: 3,
          //   },
          // },
        ]
      },

      option2 :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfSeries,
      },

      option3 :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusLoginTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfLoginSeries,
      },

      option4 :{
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: "slider", //slider表示有滑动块的，
            show: true,
            xAxisIndex: [0], //表示x轴折叠
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.censusActiveTime,
        },
        yAxis: {
          type: "value",
        },
        series: this.selfActiveSeries,
      }
    };
  },
  created() {
    this.$bus.$off("yidongreloadso");
    this.$bus.$off("pcreloadso");
  },
  async mounted() {
    await this.getInfo();
    await this.getOnline();
    await this.getLoginLog();
    await this.getActiveLog();
    this.loadEcharts();
  },
  
  methods: {
    loadEcharts(){
      let myChart = this.$echarts.init(document.getElementById("main"));
      this.option.series[0].data = this.result;
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      

      let myChart1 = this.$echarts.init(document.getElementById("main1"));
      this.option1.yAxis[0].data = this.allSoftName;
      this.option1.yAxis[1].data = this.projectCardNum;
      this.option1.series[0].data = this.onlineNum
      // console.log("this.option1:",this.option1);
      myChart1.setOption(this.option1);
      window.addEventListener("resize", function () {
        myChart1.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   myChart1.setOption(this.option1);
      //   window.addEventListener("resize", function () {
      //     myChart1.resize();
      //   });
      // });

      // let series2 = [//每个项目对应的数据
      //   {
      //     name: "梦幻西游",
      //     type: "line",
      //     //stack: "总量",
      //     data: [120, 132, 101, 134, 90, 230, 210],
      //     smooth: true,
      //   },
      // ];
      let myChart2 = this.$echarts.init(document.getElementById("main2"));
      myChart2.setOption(this.option2);
      window.addEventListener("resize", function () {
        myChart2.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   myChart2.setOption(this.option2);
      //   window.addEventListener("resize", function () {
      //     myChart2.resize();
      //   });
      // });

      let myChart3 = this.$echarts.init(document.getElementById("main3"));
      myChart3.setOption(this.option3);
      window.addEventListener("resize", function () {
        myChart3.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   myChart3.setOption(this.option3);
      //   window.addEventListener("resize", function () {
      //     myChart3.resize();
      //   });
      // });

      let myChart4 = this.$echarts.init(document.getElementById("main4"));
      myChart4.setOption(this.option4);
      window.addEventListener("resize", function () {
        myChart4.resize();
      });
      // this.$bus.$on("reloadso", function(fruit) {
      //   console.log("子组件接收自己发射的事件");
      //   myChart4.setOption(this.option4);
      //   window.addEventListener("resize", function () {
      //     myChart4.resize();
      //   });
      // });

      this.$bus.$on("yidongreloadso", (fruit)=> {
        if (fruit && this.$route.path == "/datascreen") {
          let myChart = this.$echarts.init(document.getElementById("main"));
          let myChart1 = this.$echarts.init(document.getElementById("main1"));
          let myChart2 = this.$echarts.init(document.getElementById("main2"));
          let myChart3 = this.$echarts.init(document.getElementById("main3"));
          let myChart4 = this.$echarts.init(document.getElementById("main4"));
          // console.log("this.option:",this.option);
          myChart.setOption(this.option);
          myChart1.setOption(this.option1);
          myChart2.setOption(this.option2);
          myChart3.setOption(this.option3);
          myChart4.setOption(this.option4);
          setTimeout(()=> {
            // console.log("手机重新渲染");
            myChart.resize();
            myChart1.resize();
            myChart2.resize();
            myChart3.resize();
            myChart4.resize();
          },10)
        }
      });
      this.$bus.$on("pcreloadso", (fruit)=> {
        // console.log("====this.$route.path:",this.$route.path);
        if (this.$route.path == "/datascreen") {
          let myChart = this.$echarts.init(document.getElementById("main"));
          let myChart1 = this.$echarts.init(document.getElementById("main1"));
          let myChart2 = this.$echarts.init(document.getElementById("main2"));
          let myChart3 = this.$echarts.init(document.getElementById("main3"));
          let myChart4 = this.$echarts.init(document.getElementById("main4"));
          // console.log("this.option:",this.option);
          myChart.setOption(this.option);
          myChart1.setOption(this.option1);
          myChart2.setOption(this.option2);
          myChart3.setOption(this.option3);
          myChart4.setOption(this.option4);
          setTimeout(()=> {
            // console.log("pc重新渲染");
            myChart.resize();
            myChart1.resize();
            myChart2.resize();
            myChart3.resize();
            myChart4.resize();
          },200)
        }
      });
    },
    async getInfo(){
      this.state = true;
      const result = await this.$http.get("info", {
        params: {
          email: this.email,
        },
      });
      this.state = false;
      console.log('result--->',result);
      this.allSoftName = result.data.data.resolve.allSoftName.map((element) => {
        return element.softName;
      });
      // console.log(this.allSoftName);
      result.data.data.resolve.allSoftName.forEach((element) => {
        if (element.num) {
          this.onlineNum.push(parseInt(element.num));
        } else {
          this.onlineNum.push(0);
        }
      });
      //console.log('onlineAgainNum',this.onlineAgainNum);
      this.result = result.data.data.result;
      console.log("2this.result",this.result);
      //console.log('result.data.data.result',result.data.data.result);
      this.projectCardNum = result.data.data.resolve.projectCardPasswordNum;
      //console.log('this.projectCardNum',this.projectCardNum);
      for (let i = 0; i < this.projectCardNum.length; i++) {
        if (this.projectCardNum[i] !== 0) {
          let res = this.onlineNum[i] / this.projectCardNum[i];
          this.onlineAgainNum.push(res);
        } else {
          this.onlineAgainNum.push(0);
        }
      }
      this.data = [];
      for (let i = 0; i < this.allSoftName.length; i++) {
        this.data.push(100);
      }
      return this.data;
    },
    async getOnline(){
      let online = await this.$http.get("online", {
        params: {
          email: this.email,
        },
      });
      console.log('online=',online);
      
      for(let i = 0; i < online.data.data.length; i++){
        this.censusTime.push(online.data.data[i].createDate);
        if(this.selfSeries.indexOf(online.data.data[i].softName) === -1){
          this.selfSeries.push({name: online.data.data[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      
      this.censusTime = this.unique(this.censusTime)
      console.log('this.censusTime',this.censusTime);
      let result1 = [];
      let obj = {};
      for(let i =0; i < this.selfSeries.length; i++){
        if(!obj[this.selfSeries[i].name]){
          result1.push(this.selfSeries[i]);
          obj[this.selfSeries[i].name] = true;
        }
      }
      this.selfSeries = result1
      //console.log('this.selfSeries',this.selfSeries);
      for(let i = 0; i < online.data.data.length; i++){
        //console.log('online.data.data[i].softName',online.data.data[i].softName);
        for(let j = 0; j < this.selfSeries.length; j++){
          if(online.data.data[i].softName === this.selfSeries[j].name){
            this.selfSeries[j].data.push(online.data.data[i].online)
          }
        }
      }
      console.log('this.selfSeries',this.selfSeries);
      this.$set(this.option2, 'series', this.selfSeries)
      this.$set(this.option2.xAxis, 'data', this.censusTime)
    },
    async getLoginLog(){
      const login = await this.$http.get("logins", {
        params: {
          email: this.email,
        },
      });
      console.log('login----',login);
      for(let i = 0; i < login.data.data.length; i++){
        this.censusLoginTime.push(login.data.data[i].createDate);
        
        if(this.selfLoginSeries.indexOf(login.data.data[i].softName) === -1){
          this.selfLoginSeries.push({name: login.data.data[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      this.censusLoginTime = this.unique(this.censusLoginTime)
      let result2 = [];
      let obj2 = {};
      for(let i =0; i < this.selfLoginSeries.length; i++){
        if(!obj2[this.selfLoginSeries[i].name]){
          result2.push(this.selfLoginSeries[i]);
          obj2[this.selfLoginSeries[i].name] = true;
        }
      }
      this.selfLoginSeries = result2
      //console.log('this.selfLoginSeries',this.selfLoginSeries);
      for(let i = 0; i < login.data.data.length; i++){
        //console.log('login.data.data[i].softName',login.data.data[i].softName);
        for(let j = 0; j < this.selfLoginSeries.length; j++){
          if(login.data.data[i].softName === this.selfLoginSeries[j].name){
            this.selfLoginSeries[j].data.push(login.data.data[i].login)
          }
        }
      }
      this.$set(this.option3, 'series', this.selfLoginSeries)
      this.$set(this.option3.xAxis, 'data', this.censusLoginTime)
    },
    async getActiveLog(){
      const active = await this.$http.get("activLog", {
        params: {
          email: this.email,
        },
      });
      console.log('active----',active);
      for(let i = 0; i < active.data.data.length; i++){
        this.censusActiveTime.push(active.data.data[i].createDate);
        
        if(this.selfLoginSeries.indexOf(active.data.data[i].softName) === -1){
          this.selfActiveSeries.push({name: active.data.data[i].softName, type:"line", smooth: true,data:[]})
        }
      }
      this.censusActiveTime = this.unique(this.censusActiveTime)
      let result3 = [];
      let obj3 = {};
      for(let i =0; i < this.selfActiveSeries.length; i++){
        if(!obj3[this.selfActiveSeries[i].name]){
          result3.push(this.selfActiveSeries[i]);
          obj3[this.selfActiveSeries[i].name] = true;
        }
      }
      this.selfActiveSeries = result3
      //console.log('this.selfActiveSeries',this.selfActiveSeries);
      for(let i = 0; i < active.data.data.length; i++){
        //console.log('active.data.data[i].softName',active.data.data[i].softName);
        for(let j = 0; j < this.selfActiveSeries.length; j++){
          if(active.data.data[i].softName === this.selfActiveSeries[j].name){
            this.selfActiveSeries[j].data.push(active.data.data[i].active)
          }
        }
      }
      this.$set(this.option4, 'series', this.selfActiveSeries)
      this.$set(this.option4.xAxis, 'data', this.censusActiveTime)
    },
    


    async getCardTypeSoftName() {
      this.state = true;
      // const result = await this.$http.post("cardGetSoft", {
      //   email: this.email,
      // });
      const result = await this.$http.get("info", {
        params: {
          email: this.email,
        },
      });
      this.state = false;
      console.log(result);
      this.allSoftName = result.data.data.resolve.allSoftName.map((element) => {
        return element.softName;
      });
      //console.log(this.allSoftName);
      window.sessionStorage.setItem("allSoftName", this.allSoftName);
      this.count = this.allSoftName.length * 30;
      console.log("this.count", this.count);
      window.sessionStorage.setItem("count", this.count);
      this.result = result.data.data.result;
      window.sessionStorage.setItem("result", this.result);
      this.projectCardNum = result.data.data.resolve.projectCardPasswordNum;
      window.sessionStorage.setItem("projectCardNum", this.projectCardNum);
    },
    refresh() {
      
    },
    unique(arr){
      let arr1 = [];       // 新建一个数组来存放arr中的值
      for(let i=0,len=arr.length;i<len;i++){
        if(arr1.indexOf(arr[i]) === -1){
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
    async onlineClick(index){
      if(this.onlineIndex !== index){
        console.log(index);
        this.censusTime = [],
        this.selfSeries = [],
        this.onlineIndex = index
        const online = await this.$http.get("online", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('online--',online);
        for(let i = 0; i < online.data.data.length; i++){
          this.censusTime.push(online.data.data[i].createDate);
          
          if(this.selfSeries.indexOf(online.data.data[i].softName) === -1){
            this.selfSeries.push({name: online.data.data[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        //console.log('this.censusTime',this.censusTime);
        // console.log('this.selfSeries',this.selfSeries);
        this.censusTime = this.unique(this.censusTime)
        //console.log('this.censusTime',this.censusTime);
        let result1 = [];
        let obj = {};
        for(let i =0; i < this.selfSeries.length; i++){
          if(!obj[this.selfSeries[i].name]){
            result1.push(this.selfSeries[i]);
            obj[this.selfSeries[i].name] = true;
          }
        }
        this.selfSeries = result1
        //console.log('this.selfSeries',this.selfSeries);
        for(let i = 0; i < online.data.data.length; i++){
          //console.log('online.data.data[i].softName',online.data.data[i].softName);
          for(let j = 0; j < this.selfSeries.length; j++){
            if(online.data.data[i].softName === this.selfSeries[j].name){
              this.selfSeries[j].data.push(online.data.data[i].online)
            }
          }
        }
        this.$set(this.option2, 'series', this.selfSeries)
        this.$set(this.option2.xAxis, 'data', this.censusTime)
        this.$emit("reloadso")
      }

    },

    async loginClick(index){
      if(this.loginIndex !== index){
        console.log(index);
        this.censusLoginTime = [],
        this.selfLoginSeries = [],
        this.loginIndex = index
        const login = await this.$http.get("logins", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('login----',login);
        for(let i = 0; i < login.data.data.length; i++){
          this.censusLoginTime.push(login.data.data[i].createDate);
          
          if(this.selfLoginSeries.indexOf(login.data.data[i].softName) === -1){
            this.selfLoginSeries.push({name: login.data.data[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        this.censusLoginTime = this.unique(this.censusLoginTime)
        let result1 = [];
        let obj = {};
        for(let i =0; i < this.selfLoginSeries.length; i++){
          if(!obj[this.selfLoginSeries[i].name]){
            result1.push(this.selfLoginSeries[i]);
            obj[this.selfLoginSeries[i].name] = true;
          }
        }
        this.selfLoginSeries = result1
        //console.log('this.selfLoginSeries',this.selfLoginSeries);
        for(let i = 0; i < login.data.data.length; i++){
          //console.log('login.data.data[i].softName',login.data.data[i].softName);
          for(let j = 0; j < this.selfLoginSeries.length; j++){
            if(login.data.data[i].softName === this.selfLoginSeries[j].name){
              this.selfLoginSeries[j].data.push(login.data.data[i].login)
            }
          }
        }
        this.$set(this.option3, 'series', this.selfLoginSeries)
        this.$set(this.option3.xAxis, 'data', this.censusLoginTime)
        this.$emit("reloadso")
      }
    },

    async activeClick(index){
      if(this.activeIndex !== index){
        console.log(index);
        this.censusActiveTime = [],
        this.selfActiveSeries = [],
        this.activeIndex = index
        const active = await this.$http.get("activLog", {
          params: {
            email: this.email,
            index: index
          },
        });
        console.log('active----',active);
        for(let i = 0; i < active.data.data.length; i++){
          this.censusActiveTime.push(active.data.data[i].createDate);
          
          if(this.selfLoginSeries.indexOf(active.data.data[i].softName) === -1){
            this.selfActiveSeries.push({name: active.data.data[i].softName, type:"line", smooth: true,data:[]})
          }
        }
        this.censusActiveTime = this.unique(this.censusActiveTime)
        let result3 = [];
        let obj3 = {};
        for(let i =0; i < this.selfActiveSeries.length; i++){
          if(!obj3[this.selfActiveSeries[i].name]){
            result3.push(this.selfActiveSeries[i]);
            obj3[this.selfActiveSeries[i].name] = true;
          }
        }
        this.selfActiveSeries = result3
        //console.log('this.selfActiveSeries',this.selfActiveSeries);
        for(let i = 0; i < active.data.data.length; i++){
          //console.log('active.data.data[i].softName',active.data.data[i].softName);
          for(let j = 0; j < this.selfActiveSeries.length; j++){
            if(active.data.data[i].softName === this.selfActiveSeries[j].name){
              this.selfActiveSeries[j].data.push(active.data.data[i].active)
            }
          }
        }
        this.$set(this.option4, 'series', this.selfActiveSeries)
        this.$set(this.option4.xAxis, 'data', this.censusActiveTime)
        this.$emit("reloadActive")
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  // margin: 20px;
  .el-select {
    margin-left: 10px;
  }
  .nav {
    margin: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .main-content {
    //margin: 0 16px 20px 0;
    position: relative;
    .info {
      margin-top: 5px;
      font-size: 30px;
    }
    .title {
      font-size: 14px;
      color: rgb(158, 157, 157);
    }
  }
  i {
    font-size: 50px;
  }
  .el-tooltip {
    font-size: 16px;
    position: absolute;
    top: 20px;
    right: 10px;
    cursor: pointer;
  }
}
//这句话的意思: 在我们屏幕上 并且 最小的宽度是 1600相似 设置我们想要的样式
// @media screen and (min-width: 1600px) {
@media screen and (min-width: 1200px) {
//   //一排
  .main-title {
    display: flex;

    .el-card{
      width: 50%;
    }
  }
  // .main-content {
  //   width: 55%;
  // }
  // .main-title-children {
  //   width: 50%;
  //   display: flex;
  // }
  // .el-card .last-end {
  //   margin-right: 0;
  // }
  #main #main1 #main2 {
  padding: 10px 10px 0 5px;
  //background-image: url('../assets/bg.jpg');
  // background-color: #00264a;
  }

  #main {
    margin-right: 5px;
    margin-bottom: 10px;
  }
  #main1 {
    margin-left: 5px;
    margin-bottom: 10px;
  }
  #main2 {
    //margin-right: 5px;
    margin-bottom: 20px;
  }
}

// @media screen and (min-width: 576px) and (max-width: 1599px) {
  @media screen and (min-width: 768px) and (max-width: 1199px) {
  .main-title {
    display: flex;
    .el-card{
      width: 50%;
    }
  }
//   //两排
//   // .main-title{
//   //   display: flex;
//   //   flex-wrap: wrap;
//   // }
//   .main-title-children {
//     width: 100%;
//     display: flex;
//   }
//   .main-content {
//     width: 50%;
//   }
//   .main-content:nth-child(4) {
//     margin-right: 0;
//   }
//   .main-content:nth-child(2) {
//     margin-right: 0;
//   }
#main #main1 #main2 {
  padding: 10px 10px 0 5px;
  //background-image: url('../assets/bg.jpg');
  // background-color: #00264a;
}

#main {
  margin-right: 5px;
  margin-bottom: 10px;
}
#main1 {
  margin-left: 5px;
  margin-bottom: 10px;
}
#main2 {
  //margin-right: 5px;
  margin-bottom: 20px;
}
}

// @media screen and (max-width: 575px) {
@media screen and (max-width: 767px) and (min-width:480px) {
  //四排
  .main-content {
    width: 100%;
    display: flex;
    
  }
  #main1{
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-col{
    margin: 10 0px 10px 10px;
  }
  .pbox{
    // margin: 0 0 10px 10px;
    margin: 10 0px 10px 10px !important;
    width: 100%;
  }
}

.main-title {
  margin: 5px 5px 0 5px;
  .el-card {
    padding: 10px 10px 0px 10px;
  }
}


.pbox {
  font: bold 18px/1.5em "Microsoft YaHei";
  margin: 0 5px 5px 5px;
  // display: flex;
  // width: 100%;

  // border: 1px solid deeppink;
  // overflow: hidden;
}

.online{
  display: flex;
  justify-content: space-between;
  .datelable{
    font-weight: 400;
    font-size: 13px;
  }
  span{
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 2px 10px;
    cursor: pointer;
  }
  // label{
  //   border: 1px solid #d9d9d9;
  //   border-radius: 5px;
  //   padding: 2px 10px;
  //   cursor: pointer;
  // }
  .active{
    background-color: #1890ff;
    color:#fff
  }
}
</style>